import React from 'react'

import { useConfig } from './_load/ConfigLoader'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveConfig } from './_request/saveConfig'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditConfigForm = () => {
  const config = useConfig()
  const { name } = useModalData()
  const [onSubmit, { loading, error }] = useSaveConfig()

  const findValue = value => {
    return config.value.find(rule => {
      return rule.id === value
    })
  }

  const initialState = config
    ? {
        ...config,
        value: { critic: findValue('critic')?.gte, warning: findValue('warning')?.gte }
      }
    : { name: name, value: {} }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditConfigForm
